export default __webpack_public_path__ + "static/tb_helles_04-b2cceb9769cfb26869989d708194bb63.svg";